const CollectionHero = class extends HTMLElement {
  mainHeaderHeight?: number = 0;
  collectionHeader?: HTMLElement | null;
  stickyHeader?: HTMLElement | null;
  currentScrollTop: number = 0;
  scrollBehaviourPos: number = 0;
  stickyActive: boolean = false;

  connectedCallback() {
    this.mainHeaderHeight = document.querySelector("#shopify-section-header")?.getBoundingClientRect().height || 60;
    this.collectionHeader = this.querySelector("[data-collectionheader]");
    this.stickyHeader = this.querySelector("[data-collectionstickyheader]");
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("resize", this.onResize);

    this.onResize();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
  }

  show() {
    if (!this.stickyHeader) return;
    this.stickyHeader?.classList.add("sticky-active");
    this.stickyActive = true;
  }

  hide() {
    this.stickyHeader?.classList.remove("sticky-active");
    this.stickyActive = false;
  }

  onResize() {
    const collHeaderRect = this.collectionHeader?.getBoundingClientRect();
    if (!collHeaderRect) {
      console.error("No collection header found");
      return;
    }
    if (this.stickyHeader) this.stickyHeader.style.top = this.mainHeaderHeight + "px";
    this.mainHeaderHeight = document.querySelector("#shopify-section-header")?.getBoundingClientRect().height || 60;
    this.scrollBehaviourPos = collHeaderRect.height + collHeaderRect.top - this.mainHeaderHeight;
  }

  onScroll() {
    if (this.scrollBehaviourPos === 0) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop >= this.scrollBehaviourPos && !this.stickyActive) {
      this.show();
    } else if (scrollTop < this.scrollBehaviourPos && this.stickyActive) {
      this.hide();
    }

    this.currentScrollTop = scrollTop;
  }
};

customElements.define("collection-hero", CollectionHero);
